export type authModalState = {
  modalContent: 'login' | 'registration' | 'forgot' | null;
  forgotContentText: string;
};

export const OPEN_AUTH_MODAL = 'auth/OPEN_AUTH_MODAL';
export const CLOSE_AUTH_MODAL = 'auth/CLOSE_AUTH_MODAL';
export const SET_FORGOT_TEXT = 'auth/SET_FORGOT_TEXT';
